<app-header-pink title="KONTAKT">
  <h3>Zostaw swój adres e-mail i numer telefonu.<br/>
    Skontaktujemy się z Tobą i odpowiemy na pytanie.</h3>
</app-header-pink>
<div class="container">
  <div class="card shadow">
    <div class="form">
      <div class="form-row">
        <p class="label">Imię i nazwisko</p>
        <div class="field">
          <ion-input [(ngModel)]="request.name"></ion-input>
        </div>
      </div>
      <div class="form-row">
        <p class="label">E-mail</p>
        <div class="field">
          <ion-input type="email" [(ngModel)]="request.email"></ion-input>
          <p class="error" *ngIf="request.isEmailShowValidator">Podany e-mail jest niepoprawny.</p>
        </div>
      </div>
      <div class="form-row">
        <p class="label">Tel. kom.</p>
        <div class="field">
          <ion-input type="text" [(ngModel)]="request.mobile"></ion-input>
          <p class="error" *ngIf="request.isMobileShowValidator">Podany numer jest niepoprawny.</p>
        </div>
      </div>
      <div class="form-row">
        <p class="label">Treść wiadomości</p>
        <ion-textarea rows="10" [(ngModel)]="request.message"></ion-textarea>
      </div>
      <div class="agreement-box">
        <div class="agreement">
          <p>
            Podane przez Ciebie dane będą przetwarzane przez administratora – T-Mobile Polska S.A. z siedzibą w Warszawie oraz przez administratora – „Polymus” sp. z o.o.
          </p>
        </div>
        <div class="agreement">
          <p>
            Dane wpisane w formularzu kontaktowym będą przetwarzane w celu udzielenia odpowiedzi na przesłane pytanie.
          </p>
        </div>
        <div class="agreement">
          <p>
            Więcej informacji o tym, jak przetwarzane są Twoje dane i o przysługujących Ci prawach znajdziesz w naszej <a class="underline" href="{{ httpHelper.servicePath }}/docs/klauzula-informacyjna.pdf" target="_blank">klauzuli informacyjnej.</a>
          </p>
        </div>
      </div>
      <ion-button class="btn-custom" (click)="onWyslijWiadomosc_click()">Wyślij wiadomość</ion-button>
    </div>
  </div>
</div>
